import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { companyInfo } from '../data/mock';

const About = () => {
  return (
    <section id="about" className="py-16 lg:py-24 bg-white overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center max-w-7xl mx-auto">
          
          {/* Left Image */}
          <motion.div 
            className="relative order-2 lg:order-1"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="relative rounded-2xl overflow-hidden shadow-2xl group">
              <div className="absolute inset-0 bg-blue-900/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10"></div>
              <motion.img
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=800&q=80"
                alt="About Teqvis Technologies"
                className="w-full h-auto object-cover transform transition-transform duration-700 group-hover:scale-110"
              />
            </div>

            {/* Stats Overlay */}
            <motion.div 
              className="absolute -bottom-6 -right-6 bg-white rounded-xl shadow-xl p-6 max-w-xs z-20 border border-gray-100"
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.4 }}
              whileHover={{ y: -5, boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)" }}
            >
              <div className="grid grid-cols-2 gap-8">
                <div className="text-center">
                  <div className="text-3xl font-bold text-blue-900">10+</div>
                  <div className="text-xs text-gray-600 uppercase tracking-wide mt-1">Years Exp.</div>
                </div>
                <div className="text-center border-l border-gray-200 pl-4">
                  <div className="text-3xl font-bold text-blue-900">50+</div>
                  <div className="text-xs text-gray-600 uppercase tracking-wide mt-1">Clients</div>
                </div>
              </div>
            </motion.div>

            {/* Decorative Element */}
            <div className="absolute -z-10 top-10 -left-10 w-40 h-40 bg-blue-100 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob"></div>
            <div className="absolute -z-10 -bottom-10 -right-10 w-40 h-40 bg-indigo-100 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob animation-delay-2000"></div>
          </motion.div>

          {/* Right Content */}
          <motion.div 
            className="space-y-8 order-1 lg:order-2"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div>
              <motion.span 
                className="inline-block px-4 py-1 rounded-full bg-blue-50 text-blue-900 font-medium text-sm mb-4"
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
              >
                About {companyInfo.name}
              </motion.span>
              <h2 className="text-3xl lg:text-5xl font-bold text-gray-900 leading-tight">
                Who We Are
              </h2>
            </div>

            <div className="space-y-6 text-lg text-gray-600">
              <p className="leading-relaxed">
                {companyInfo.description}
              </p>
              <p className="leading-relaxed">
                Based in <span className="font-semibold text-blue-900">Calicut, Kerala</span>, we serve clients across India and internationally. Our hybrid delivery model ensures flexibility and efficiency in every project we undertake.
              </p>
            </div>

            {/* Mission Points */}
            <div className="space-y-4 pt-4">
              {[
                { title: "Practical Solutions", desc: "Technology that solves real business problems" },
                { title: "Honest Pricing", desc: "Transparent quotations with no hidden costs" },
                { title: "Long-term Support", desc: "We're your technology partner for the long haul" }
              ].map((item, idx) => (
                <motion.div 
                  key={idx}
                  className="flex items-start space-x-4 p-4 rounded-xl hover:bg-gray-50 transition-colors duration-300"
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.4 + idx * 0.1 }}
                  whileHover={{ x: 10 }}
                >
                  <div className="w-2 h-2 bg-gradient-to-r from-blue-600 to-indigo-700 rounded-full mt-2.5 flex-shrink-0"></div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1 text-lg">{item.title}</h3>
                    <p className="text-gray-600">{item.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          
            {/* Read More Button - Hidden
            <motion.div
              className="pt-6"
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6 }}
            >
              <Link to="/about">
                <Button className="bg-blue-100 text-blue-900 hover:bg-blue-200 hover:text-blue-950 font-semibold px-8 py-6 rounded-xl text-lg transition-all duration-300">
                  Read More About Us
                </Button>
              </Link>
            </motion.div>
            */}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
